var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-progress-linear',{staticClass:"progress",attrs:{"color":"green darken-4 accent-4","indeterminate":"","rounded":"","height":"6"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }